import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../components/layout/table-container/table-container";
import { faqVersionList } from "../../redux/actions/faqActions";
import FaqVersionTableData from "./faq-version-list-table-data";
import LoadingSpinnerTable from "../../components/utilites/loaderSpinningContainer";
import NumberPagination from "../../components/Pagination/number-pagination";

const FaqVersionTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [faqVersionListData, setfaqVersionListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    fetchFaqVersionList();
  }, [page, search]);

  const fetchFaqVersionList = () => {
    dispatch(faqVersionList({ search, page }, onSuccess, onError));
    setLoading(true);
  };

  const onSuccess = (data) => {
    setfaqVersionListData(data.data.data);
    setLoading(false);
  };

  const onError = (err) => {
    setLoading(false);
  };

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              FAQ ID
            </th>
            <th className="table-heads " width={"10%"}>
              FAQ Questions
            </th>

            <th className="table-heads " width={"10%"}>
              Created for
            </th>
            <th className="table-heads " width={"10%"}>
              Created By
            </th>
            <th className="table-heads " width={"15%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : faqVersionListData?.faqs?.length > 0 ? (
            <>
              {faqVersionListData?.faqs?.map((eachRow, index) => (
                <FaqVersionTableData
                  data={eachRow}
                  key={eachRow.id}
                  index={index}
                  fetchFaqVersionList={fetchFaqVersionList}
                  currentPage={faqVersionListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {faqVersionListData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={faqVersionListData?.pagination?.currentPage}
            totalPages={faqVersionListData?.pagination?.totalPages}
            path={"/faq/version-list"}
            filters={`${queryString}`}
          />
        )}
      </div>
    </>
  );
};

export default FaqVersionTable;
